import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function PageHeader({ title, crumb, subtitle }) {
  return (
    <section className="section-dark text-white pt-16 pb-20 relative overflow-hidden">
      <div className="absolute -top-20 right-0 w-96 h-96 rounded-full bg-[#D4AF37]/10 blur-3xl" />
      <div className="container-x relative">
        <nav className="flex items-center gap-2 text-sm text-slate-400 mb-4">
          <Link to="/" className="hover:text-[#D4AF37]">Home</Link>
          <ChevronRight size={14} />
          <span className="text-[#D4AF37]">{crumb || title}</span>
        </nav>
        <h1 className="font-head text-4xl md:text-5xl font-extrabold tracking-tight">{title}</h1>
        {subtitle && (
          <p className="mt-4 text-slate-300 max-w-2xl text-[17px] leading-relaxed">{subtitle}</p>
        )}
      </div>
    </section>
  );
}
